var map = {
  "./AuthorWidget/AuthorWidget.js": [
    "79732",
    9,
    "9291"
  ],
  "./mobile": [
    "91302",
    9,
    "30083",
    "47387",
    "3199",
    "6937",
    "38154",
    "17189",
    "40661",
    "63318",
    "13454"
  ],
  "./desktop": [
    "64504",
    9,
    "76225",
    "62815",
    "79235",
    "47387",
    "3199",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "40661",
    "63318",
    "83514"
  ],
  "./mobile/author": [
    "35527",
    9,
    "47387",
    "40661",
    "34432"
  ],
  "./mobile/index": [
    "91302",
    9,
    "30083",
    "47387",
    "3199",
    "6937",
    "38154",
    "17189",
    "40661",
    "63318",
    "13454"
  ],
  "./AuthorWidget/AuthorWidget.scss": [
    "91088",
    7,
    "6096"
  ],
  "./desktop/index.js": [
    "64504",
    9,
    "76225",
    "62815",
    "79235",
    "47387",
    "3199",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "40661",
    "63318",
    "83514"
  ],
  "./desktop/index": [
    "64504",
    9,
    "76225",
    "62815",
    "79235",
    "47387",
    "3199",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "40661",
    "63318",
    "83514"
  ],
  "./mobile/author.js": [
    "35527",
    9,
    "47387",
    "40661",
    "34432"
  ],
  "./AuthorWidget/AuthorWidget": [
    "79732",
    9,
    "9291"
  ],
  "./desktop/": [
    "64504",
    9,
    "76225",
    "62815",
    "79235",
    "47387",
    "3199",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "40661",
    "63318",
    "83514"
  ],
  "./mobile/": [
    "91302",
    9,
    "30083",
    "47387",
    "3199",
    "6937",
    "38154",
    "17189",
    "40661",
    "63318",
    "13454"
  ],
  "./desktop/author.js": [
    "27329",
    9,
    "47387",
    "40661",
    "28740"
  ],
  "./mobile/index.js": [
    "91302",
    9,
    "30083",
    "47387",
    "3199",
    "6937",
    "38154",
    "17189",
    "40661",
    "63318",
    "13454"
  ],
  "./desktop/author": [
    "27329",
    9,
    "47387",
    "40661",
    "28740"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
    return __webpack_require__.t(id, ids[1] | 16);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 32978;
module.exports = __rspack_async_context;
